var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import moment from "moment";
import { Divider } from "@material-ui/core";
import { container } from "../../inversify/inversify.config";
import { TYPES } from "../../inversify/types";
import { Redirect } from "react-router-dom";
import { ClientLedgerParams } from "../../helpers/Domain/ViewModels/Reports/ClientLedgerParams";
import { DropdownWithCheckBox } from "../../common/DropdownWithCheckBox";
import { CompanyReturnDeliveryModes } from "../../common/helper";
import DateFnsUtils from "material-ui-pickers/utils/moment-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/MuiPickersUtilsProvider";
import DatePicker from "material-ui-pickers/DatePicker";
import Grid from "@material-ui/core/Grid";
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import { getReturnDeliveryMode, getCurrentYearFirstDay, } from "../../common/Validation";
import { Toaster } from "../../common/Toaster";
var notification = container.get(TYPES.INotification);
var ExtensionClientLedgerFilter = /** @class */ (function (_super) {
    __extends(ExtensionClientLedgerFilter, _super);
    function ExtensionClientLedgerFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFromDateChange = function (date) {
            _this.setState({ fromDate: moment(date).format("MM/DD/YYYY") });
        };
        _this.handleToDateChange = function (date) {
            _this.setState({ toDate: moment(date).format("MM/DD/YYYY") });
        };
        _this.loadDeliveryModes = function () {
            var _self = _this;
            var arr = [];
            CompanyReturnDeliveryModes.map(function (deliveryMode) {
                var temp = { value: deliveryMode.Key, label: deliveryMode.value };
                if (arr.find(function (o) { return o.value === deliveryMode.Key; }) == undefined) {
                    arr.push(temp);
                }
            });
            _self.setState({ deliveryModes: arr, selectedDeliveryMode: arr[0].Key });
        };
        _this.filter = function () {
            if (_this.validateDate() && _this.validateCompany()) {
                _this.props.filter(new ClientLedgerParams(_this.state.fromDate, _this.state.toDate, _this.props.selectedCompanyValue.value, _this.state.selectedDeliveryMode ? _this.state.selectedDeliveryMode : 0));
            }
        };
        _this.handleDeliveryModeChange = function (selectedValue) {
            _this.setState({ selectedDeliveryMode: selectedValue.value });
        };
        _this.state = {
            fromDate: getCurrentYearFirstDay(),
            toDate: new Date(),
            clientLedgerExpansionPanel: "clientLedgerExpansionPanel",
            toManulaPay: false,
            isHideTestCompanySelected: false,
            companyList: [],
            selectedDeliveryMode: getReturnDeliveryMode(),
            deliveryModes: [],
        };
        return _this;
    }
    ExtensionClientLedgerFilter.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.companyData != this.props.companyData) {
            var arr_1 = [];
            nextProps.companyData.map(function (compDetail) {
                var temp = {
                    value: compDetail.CompanyId,
                    label: compDetail.CompanyName,
                };
                arr_1.push(temp);
            });
            this.setState({ companyList: arr_1 });
            this.loadDeliveryModes();
        }
    };
    ExtensionClientLedgerFilter.prototype.validateCompany = function () {
        if (this.props.selectedCompanyValue.value == 0 ||
            this.props.selectedCompanyValue.value == undefined) {
            notification.warn("Please select a Company.");
            return false;
        }
        return true;
    };
    ExtensionClientLedgerFilter.prototype.validateDate = function () {
        if (Date.parse(this.state.fromDate.toLocaleString()) >
            Date.parse(this.state.toDate.toLocaleString())) {
            notification.warn("From Date cannot be greater than To Date.");
            return false;
        }
        return true;
    };
    ExtensionClientLedgerFilter.prototype.toggleClass = function () {
        this.setState({
            clientLedgerExpansionPanel: this.state.clientLedgerExpansionPanel == ""
                ? "clientLedgerExpansionPanel"
                : "",
        });
    };
    ExtensionClientLedgerFilter.prototype.render = function () {
        var _this = this;
        if (this.state.toManulaPay === true) {
            return (_jsx(Redirect, { to: {
                    pathname: "/Purchase",
                    state: {
                        defaultCompanyId: this.props.selectedCompanyValue.value,
                        defaultProductType: 1,
                    },
                } }));
        }
        return (_jsx("div", __assign({ className: this.state.clientLedgerExpansionPanel }, { children: _jsxs(Accordion, __assign({ defaultExpanded: true }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, {}), onClick: function () {
                            _this.toggleClass();
                        } }, { children: _jsx(Typography, __assign({ style: { fontWeight: "bold", fontSize: '13px' } }, { children: "Transaction History" })) })), _jsx(AccordionActions, __assign({ style: { paddingLeft: "28px" } }, { children: _jsx(Grid, { container: true }) })), _jsx(AccordionDetails, { children: _jsx(Grid, __assign({ container: true, lg: 12 }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsx(Grid, __assign({ item: true, lg: 3, className: "martop17 clientLedgerDatePicker" }, { children: _jsx(MuiPickersUtilsProvider, __assign({ utils: DateFnsUtils }, { children: _jsx(DatePicker, { name: "fromdate", keyboard: true, label: "From Date", format: "MM/DD/YYYY", placeholder: "MM/DD/YYYY", 
                                                // handle clearing outside => pass plain array if you are not controlling value outside
                                                mask: function (value) {
                                                    return value
                                                        ? [
                                                            /\d/,
                                                            /\d/,
                                                            "/",
                                                            /\d/,
                                                            /\d/,
                                                            "/",
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                        ]
                                                        : [];
                                                }, value: this.state.fromDate, onChange: this.handleFromDateChange, animateYearScrolling: false, InputLabelProps: { shrink: true } }) })) })), _jsx(Grid, __assign({ item: true, lg: 3, className: "martop17 clientLedgerDatePicker" }, { children: _jsx(MuiPickersUtilsProvider, __assign({ utils: DateFnsUtils }, { children: _jsx(DatePicker, { name: "todate", keyboard: true, label: "To Date", format: "MM/DD/YYYY", placeholder: "MM/DD/YYYY", 
                                                // handle clearing outside => pass plain array if you are not controlling value outside
                                                mask: function (value) {
                                                    return value
                                                        ? [
                                                            /\d/,
                                                            /\d/,
                                                            "/",
                                                            /\d/,
                                                            /\d/,
                                                            "/",
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                        ]
                                                        : [];
                                                }, value: this.state.toDate, onChange: this.handleToDateChange, animateYearScrolling: false, InputLabelProps: { shrink: true } }) })) })), _jsx(Grid, __assign({ item: true, lg: 4, className: "martop17 clientLedgerDatePicker" }, { children: _jsx(DropdownWithCheckBox, { handleSelectBox: this.props.handleCompanyChange, selectBoxOptions: this.state.companyList, selectBoxLabel: "Company", selectedValue: this.props.selectedCompanyValue, placeHolderText: "Select Company...", defaultCheck: this.state.isHideTestCompanySelected }) })), _jsx(Grid, __assign({ item: true, lg: 2, className: " clientLedgerDatePicker" }, { children: _jsx(Button, __assign({ style: {
                                                marginTop: "24px",
                                                float: "right",
                                            }, variant: "outlined", size: "small", onClick: this.filter, color: "primary" }, { children: "Filter" })) }))] })) })) }), _jsx(Divider, {}), _jsx(AccordionActions, __assign({ className: "custom-accordion-actions" }, { children: _jsx(Button, __assign({ variant: "outlined", size: "small", onClick: this.props.downloadAsExcel, color: "default", className: "ext-filter-btn" }, { children: "Download" })) })), _jsx(Toaster, {})] })) })));
    };
    return ExtensionClientLedgerFilter;
}(React.Component));
export { ExtensionClientLedgerFilter };
